import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// 首页用重定向的方式来进行适配的方案：
const redirectPath = window.isMobile() ? '/mobile' : '/home';
import { constantRoutes } from '../../router/pc/index';
import { constantMobileRoutes } from '../../router/mobile/index';
// 默认路由
const routes = [
  {
    path: "/",
    redirect: redirectPath,
  }
]

const newRoutes = routes.concat(redirectPath === '/mobile' ? constantMobileRoutes : constantRoutes);
// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   newRoutes
// })

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: newRoutes
})

const router = createRouter();
// 重置路由表
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}


// router.beforeEach((to, from, next) => {
//   if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
//     window.location.href = '/mobile.html/'
//     return
//   }
//   next()
// })

export default router




